import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('material-card', _vm._g(_vm._b({
    staticClass: "v-card--material-stats"
  }, 'material-card', _vm.$attrs, false), _vm.$listeners), [_c(VCard, {
    class: `elevation-${_vm.elevation}`,
    staticStyle: {
      "padding": "0px 10px !important"
    },
    attrs: {
      "slot": "offset",
      "color": _vm.color,
      "dark": ""
    },
    slot: "offset"
  }, [_c(VIcon, {
    attrs: {
      "size": "35"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")])], 1), _c('div', {
    staticClass: "text-right"
  }, [_c('core-favoriteselect', {
    attrs: {
      "userId": _vm.favUserId,
      "objectId": _vm.favObjectId,
      "type": _vm.favType
    }
  }), _c('p', {
    staticClass: "category grey--text mt-4"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _c('h3', {
    staticClass: "text-h6 text-h4",
    staticStyle: {
      "height": "70px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.value) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.smallValue))])]), _c('div', {
    staticClass: "grey--text"
  }, _vm._l(_vm.accessKeyDates.days, function (item, index) {
    return _c(VChip, {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t(`Common.${[_vm.days[item]]}`)) + "\n      ")]);
  }), 1), _vm.accessKeyDates.timeFrom && _vm.accessKeyDates.timeTo ? _c('p', {
    staticClass: "grey--text mt-2 text-caption"
  }, [_vm._v("\n      " + _vm._s(_vm.accessKeyDates.timeFrom) + "h - " + _vm._s(_vm.accessKeyDates.timeTo) + "h\n    ")]) : _vm._e(), _vm.accessKeyDates.dateFrom && _vm.accessKeyDates.dateTo ? _c('p', {
    staticClass: "grey--text mt-2 text-caption"
  }, [_vm._v("\n      " + _vm._s(_vm.accessKeyDates.dateFrom) + " - " + _vm._s(_vm.accessKeyDates.dateTo) + "\n    ")]) : _vm._e()], 1), _vm.button ? _c('div', {
    staticClass: "text-center"
  }, [_c(VBtn, {
    staticClass: "v-btn-x mt-4 mb-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": _vm.buttoncolor
    },
    on: {
      "click": function ($event) {
        return _vm.processDoor(_vm.value);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.button) + "\n    ")])], 1) : _vm._e(), _c('template', {
    slot: "actions"
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "color": _vm.subIconColor,
      "size": "30"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.subIcon) + "\n    ")]), _c('span', {
    staticClass: "text-caption",
    class: _vm.subTextColor,
    domProps: {
      "textContent": _vm._s(_vm.subText)
    }
  })], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };